<template>
	<div
		v-if="$store.cID"
		:class="['wishlist-btn', { 'active': inWishlist }]">
		<button
			type="button"
			@click.prevent="updateWishlist()">
			<Loading v-if="wishlistLoading" :activated="true" />
			<IconWishlist v-else :inWishlist="inWishlist" />
		</button>
	</div>
</template>

<script>
import IconWishlist from '../Icons/IconWishlist'
import Loading from '../Components/Loading'

export default {
	name: 'WishlistButton',

	components: { IconWishlist, Loading },

	props: {
		pid: {
			type: Number,
			required: true
		},
		vid: {
			type: Number,
			required: true
		}
	},

	data () {
		return {
			wishlistLoading: false
		}
	},

	computed: {
		inWishlist () {
			if (this.$store.cID === null) return false
			if (this.$store.wishlist === null) return false
			if (this.$isEmpty(this.$store.wishlist.list)) return false

			// not using multi wishlist setup
			let items = Object.values(this.$store.wishlist.list)[0].items
			return items.some(i => i.vid === this.vid)
		},

		storeLoading () {
			return this.$store.loading
		}
	},

	methods: {
		updateWishlist () {
			this.wishlistLoading = true
			let listKey = Object.keys(this.$store.wishlist.list)[0]
			this.$actions.updateWishlist(this.pid, this.vid, this.inWishlist, listKey)
		}
	},

	watch: {
		storeLoading () {
			if (this.$store.loading == false) {
				this.wishlistLoading = false
			}
		}
	}
}
</script>
